import {filter} from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';
import {PledgeType} from '../../../services/api.client';
import {PledgeTypeService} from '../../../services/PledgeTypeService';
import {Observable} from 'rxjs';

@Component({
    selector: '[efsPledgeTypes]',
    templateUrl: './EfsPledgeTypeDropdown.html',
    standalone: false
})
export class EfsPledgeTypeDropdown implements OnInit {
  pledgeTypes: PledgeType[] = [];
  pledgeTypes$: Observable<PledgeType[]>;

  constructor(private _pledgeTypeService: PledgeTypeService) {
    this.pledgeTypes$ = this._pledgeTypeService.allPledgeTypes$;
  }

  ngOnInit(): void {
    this.pledgeTypes$.pipe(
      filter(pledgeTypes => !pledgeTypes))
      .subscribe(() => {
        this._pledgeTypeService.getAllPledgeTypes()
          .subscribe((pledgeTypes) => {
            this.pledgeTypes = pledgeTypes.filter(pledgeType => pledgeType && pledgeType.isEfs === true);
          });
      });
  }
}
